import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const AnalyticsIcon = (props: IconProps) => {
  return (
    <Icon
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M.5 23.5h23M4.5 19a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v4.5h3Zm6-5a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v9.5h3Zm6 2a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v7.5h3Zm6-7a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v14.5h3Z" />
      <circle cx="3" cy="11.5" r="1.5" />
      <circle cx="9" cy="6.5" r="1.5" />
      <circle cx="15" cy="8.5" r="1.5" />
      <circle cx="21" cy="2" r="1.5" />
      <path d="m4.26 10.45 3.59-2.99m2.57-.49 3.16 1.06M19.8 2.9l-3.76 4.39" />
    </Icon>
  );
};

export default AnalyticsIcon;
